import { GroupedExtraInfo } from 'app/components/access-panel/extra-info/types';
import { ExtraInfoCodeValues, ExtraInfoWireFormat } from 'app/components/access-panel/shared/types';

export const createExtraInfoValues =
  (extraInfoCodesValues: ExtraInfoCodeValues[], initialValue: ExtraInfoWireFormat[]): GroupedExtraInfo[] => {
    return extraInfoCodesValues
      .map(extraInfoCodesValue => ({
        extraInfoCodesValue,
        initialValues: initialValue.filter(item => item.extraInfo.v === extraInfoCodesValue.id)
      }));
  };
